import React, { useContext, useEffect, useState } from "react";
import { TextField, Button, MenuItem } from "@mui/material";
import { ContextData } from "../../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../BaseURL";
import SoundAlert from "../../../../../../routes/SoundAlert";
import { Putrequest } from "../../../../../../context/AxiosRequest";

function SalaryBankDetails({ formData }) {
  const { UserTokens, ReloadBioForms, setReloadBioForms } = useContext(ContextData);

  const [formDatas, setFormDatas] = useState({
    account_name: "",
    bank: "",
    account_number: "",
    account_type: "",
    signature_date: "",
  });

  const handleChange =  (e) => {
    const { name, value } = e.target;
    setFormDatas((prev) => ({ ...prev, [name]: value }));
  };

  const validateField = (type, value) => {
    
    if (type === "account_number") {
      return /^\d{11,15}$/.test(value.trim()); // numbers only, max 15 digits
    }
    return value.trim() !== "";
  };

  const handleSubmit = async (type) => {


    if (!validateField(type, formDatas[type])) {
      SoundAlert("error");
      toast.error("Please fill in this field correctly.");
      return;
    }

   
               const response = await Putrequest("auth/update_salary_bank_details",{...formDatas,user_token:UserTokens})
   
               
                   if(response.status){

                    SoundAlert("success")
                    toast.success(response.textStatus)
                    setReloadBioForms(!ReloadBioForms)

                     }



           };

  

    useEffect(()=>{

           setFormDatas({
              account_name: formData.salary_bank_details.account_name || "",
              bank: formData.salary_bank_details.bank  || "",
              account_number: formData.salary_bank_details.account_number || "",
              account_type: formData.salary_bank_details.account_type || "",
              signature_date: formData.salary_bank_details.signature_date || "",
           })
    
    },[formData])




  return (
    <div className="pt-2 pb-2">
      {/* Account Name */}
      <TextField
        label="Account Name"
        name="account_name"
        value={formDatas.account_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("account_name")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Bank */}
      <TextField
        label="Bank Name"
        name="bank"
        value={formDatas.bank}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("bank")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Account Number */}
      <TextField
        label="Account Number"
        name="account_number"
        value={formDatas.account_number}
        onChange={handleChange}
        type="tel"
        fullWidth
        margin="dense"
        required
        inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("account_number")}>
              Save
            </Button>
          ),
           maxLength: 10
        }}
      />

      {/* Account Type */}
      <TextField
        select
        label="Account Type"
        name="account_type"
        value={formDatas.account_type}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("account_type")}>
              Save
            </Button>
          ),
        }}
      >
        <MenuItem value="Savings">Savings</MenuItem>
        <MenuItem value="Current">Current</MenuItem>
        <MenuItem value="Salary">Salary</MenuItem>
        <MenuItem value="Other">Other</MenuItem>
      </TextField>

      {/* Acknowledgement */}
     {/*  <p className="pt-4 pb-2 text-sm text-gray-700 leading-relaxed">
        I, ___________________________________________ acknowledge that all information and documents provided by me are genuine,  
        and if it is found otherwise, my application should be rendered void.
      </p> */}

      {/* Signature/Date */}
     {/*  <TextField
        label="Signature / Date"
        name="signature_date"
        value={formDatas.signature_date}
        onChange={handleChange}
        type="date"
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("signature_date")}>
              Save
            </Button>
          ),
        }}
      /> */}
    </div>
  );
}

export default SalaryBankDetails;
